module.exports = __webpack_public_path__ + "static/media/ball.f53816bc.svg";